import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DataTable from 'src/shared/components/DataTable';
import { getRecordContentApi } from './ApiService';
import { Button } from 'antd';
import ReadBookModal from './ReadBookModal';

const Wrapper = styled.div`
  button:hover span {
    color: inherit !important;
  }
`;

function BookChapter({ id }) {
  const [chapters, setChapters] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const [dataText, setDataText] = useState('');
  const [fileExtension, setFileExtension] = useState('');

  const getConent = () => {
    const params = { id, type: 'chapter' };
    getRecordContentApi(params).then((data) => {
      setChapters(data);
    });
  };

  const openModal = ({ fileUrl, dataText }) => {
    setFileUrl(fileUrl);
    setDataText(dataText);
    const fileExtension = fileUrl.split('.').pop();
    setFileExtension(fileExtension);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };


  const columns = [
    {
      title: 'Tiêu đề',
      dataIndex: 'Title',
      key: 'Title',
    },
    {
      title: 'Trang',
      dataIndex: 'Page',
      render: (text, record) => {
        if (text.includes('http')) {
          return <Button type='link' onClick={() => openModal({ fileUrl: text, dataText: record.Title })} target="_blank">Xem File Mục Lục</Button>;
        }
        return text;
      },
      key: 'Page',
    },
  ];

  useEffect(() => {
    getConent();
  }, []);

  return (
    <Wrapper>
      <DataTable dataSource={chapters} columns={columns} />
      {isModalOpen && (
        <ReadBookModal
          isModalOpen={isModalOpen}
          handleCancel={closeModal}
          handleOk={closeModal}
          fileUrl={fileUrl}
          extension={fileExtension}
          dataText={dataText}
        />
      )}
    </Wrapper>
  );
}

export default BookChapter;
